import { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';

// Contextos
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

// Estilos
import styles from './loginpage.module.css';

const COUNTRY_OPTIONS = [
    { iso: 'BR', ddi: '55', name: 'Brasil', placeholder: '(11) 91234-5678', minLength: 11, maxLength: 11 },
    { iso: 'US', ddi: '1', name: 'Estados Unidos', placeholder: '201 555 0123', minLength: 10, maxLength: 10 },
    { iso: 'CA', ddi: '1', name: 'Canada', placeholder: '416 555 0123', minLength: 10, maxLength: 10 },
    { iso: 'PT', ddi: '351', name: 'Portugal', placeholder: '912 345 678', minLength: 9, maxLength: 9 },
    { iso: 'GB', ddi: '44', name: 'Reino Unido', placeholder: '7123 456789', minLength: 9, maxLength: 11 },
    { iso: 'ES', ddi: '34', name: 'Espanha', placeholder: '612 345 678', minLength: 9, maxLength: 9 },
    { iso: 'FR', ddi: '33', name: 'Franca', placeholder: '6 12 34 56 78', minLength: 9, maxLength: 9 },
    { iso: 'DE', ddi: '49', name: 'Alemanha', placeholder: '1512 3456789', minLength: 7, maxLength: 11 },
    { iso: 'IT', ddi: '39', name: 'Italia', placeholder: '312 345 6789', minLength: 8, maxLength: 11 },
    { iso: 'JP', ddi: '81', name: 'Japao', placeholder: '90 1234 5678', minLength: 9, maxLength: 10 },
    { iso: 'MX', ddi: '52', name: 'Mexico', placeholder: '55 1234 5678', minLength: 10, maxLength: 10 },
    { iso: 'AR', ddi: '54', name: 'Argentina', placeholder: '11 2345 6789', minLength: 10, maxLength: 11 },
    { iso: 'CL', ddi: '56', name: 'Chile', placeholder: '9 1234 5678', minLength: 9, maxLength: 9 },
    { iso: 'CO', ddi: '57', name: 'Colombia', placeholder: '312 345 6789', minLength: 10, maxLength: 10 },
    { iso: 'PE', ddi: '51', name: 'Peru', placeholder: '912 345 678', minLength: 9, maxLength: 9 },
    { iso: 'AU', ddi: '61', name: 'Australia', placeholder: '412 345 678', minLength: 9, maxLength: 9 },
    { iso: 'NZ', ddi: '64', name: 'Nova Zelandia', placeholder: '21 234 5678', minLength: 8, maxLength: 10 },
    { iso: 'IE', ddi: '353', name: 'Irlanda', placeholder: '85 123 4567', minLength: 9, maxLength: 9 },
    { iso: 'NL', ddi: '31', name: 'Holanda', placeholder: '6 1234 5678', minLength: 9, maxLength: 9 },
    { iso: 'BE', ddi: '32', name: 'Belgica', placeholder: '470 12 34 56', minLength: 9, maxLength: 9 },
    { iso: 'CH', ddi: '41', name: 'Suica', placeholder: '79 123 45 67', minLength: 9, maxLength: 9 },
    { iso: 'AT', ddi: '43', name: 'Austria', placeholder: '664 1234567', minLength: 7, maxLength: 11 },
    { iso: 'SE', ddi: '46', name: 'Suecia', placeholder: '70 123 45 67', minLength: 7, maxLength: 10 },
    { iso: 'NO', ddi: '47', name: 'Noruega', placeholder: '412 34 567', minLength: 8, maxLength: 8 },
    { iso: 'DK', ddi: '45', name: 'Dinamarca', placeholder: '20 12 34 56', minLength: 8, maxLength: 8 },
    { iso: 'FI', ddi: '358', name: 'Finlandia', placeholder: '40 123 4567', minLength: 8, maxLength: 10 },
    { iso: 'PL', ddi: '48', name: 'Polonia', placeholder: '512 345 678', minLength: 9, maxLength: 9 },
    { iso: 'CZ', ddi: '420', name: 'Republica Checa', placeholder: '601 123 456', minLength: 9, maxLength: 9 },
    { iso: 'HU', ddi: '36', name: 'Hungria', placeholder: '20 123 4567', minLength: 9, maxLength: 9 },
    { iso: 'GR', ddi: '30', name: 'Grecia', placeholder: '691 234 5678', minLength: 10, maxLength: 10 },
    { iso: 'TR', ddi: '90', name: 'Turquia', placeholder: '532 123 4567', minLength: 10, maxLength: 10 },
    { iso: 'IL', ddi: '972', name: 'Israel', placeholder: '52 123 4567', minLength: 9, maxLength: 9 },
    { iso: 'AE', ddi: '971', name: 'Emirados Arabes', placeholder: '50 123 4567', minLength: 9, maxLength: 9 },
    { iso: 'SA', ddi: '966', name: 'Arabia Saudita', placeholder: '50 123 4567', minLength: 9, maxLength: 9 },
    { iso: 'ZA', ddi: '27', name: 'Africa do Sul', placeholder: '71 234 5678', minLength: 9, maxLength: 9 },
    { iso: 'EG', ddi: '20', name: 'Egito', placeholder: '100 123 4567', minLength: 10, maxLength: 10 },
    { iso: 'IN', ddi: '91', name: 'India', placeholder: '91234 56789', minLength: 10, maxLength: 10 },
    { iso: 'PK', ddi: '92', name: 'Paquistao', placeholder: '301 2345678', minLength: 10, maxLength: 10 },
    { iso: 'BD', ddi: '880', name: 'Bangladesh', placeholder: '1712 345678', minLength: 10, maxLength: 10 },
    { iso: 'CN', ddi: '86', name: 'China', placeholder: '13 1234 5678', minLength: 11, maxLength: 11 },
    { iso: 'KR', ddi: '82', name: 'Coreia do Sul', placeholder: '10 1234 5678', minLength: 9, maxLength: 10 },
    { iso: 'HK', ddi: '852', name: 'Hong Kong', placeholder: '9123 4567', minLength: 8, maxLength: 8 },
    { iso: 'SG', ddi: '65', name: 'Singapura', placeholder: '8123 4567', minLength: 8, maxLength: 8 },
    { iso: 'MY', ddi: '60', name: 'Malasia', placeholder: '12 345 6789', minLength: 9, maxLength: 10 },
    { iso: 'TH', ddi: '66', name: 'Tailandia', placeholder: '81 234 5678', minLength: 9, maxLength: 9 },
    { iso: 'VN', ddi: '84', name: 'Vietna', placeholder: '91 234 5678', minLength: 9, maxLength: 10 },
    { iso: 'PH', ddi: '63', name: 'Filipinas', placeholder: '917 123 4567', minLength: 10, maxLength: 10 },
    { iso: 'ID', ddi: '62', name: 'Indonesia', placeholder: '812 3456 7890', minLength: 9, maxLength: 12 },
];

function LoginPage() {
    const { login, isAuthenticated } = useAuth();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const countries = useMemo(() => COUNTRY_OPTIONS, []);
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);
    const [countryQuery, setCountryQuery] = useState(countries[0].iso);
    const [telefone, setTelefone] = useState('');
    const [senha, setSenha] = useState('');
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(false);

    const telefoneInputRef = useRef(null);

    const aplicarMascaraTelefone = (valor, pais) => {
        const numeros = valor.replace(/\D/g, '');

        if (pais.iso !== 'BR') {
            return numeros.slice(0, pais.maxLength || 14);
        }

        const limpo = numeros.slice(0, 11);
        const parte1 = limpo.slice(0, 2);
        const parte2 = limpo.slice(2, 7);
        const parte3 = limpo.slice(7, 11);

        if (limpo.length <= 2) return parte1 ? `(${parte1}` : '';
        if (limpo.length <= 7) return `(${parte1}) ${parte2}`;
        return `(${parte1}) ${parte2}-${parte3}`;
    };

    const handleTelefoneChange = (e) => {
        const valor = e.target.value;
        setTelefone(aplicarMascaraTelefone(valor, selectedCountry));
    };

    const normalizeCountryValue = (value) => value.toLowerCase().replace(/[^a-z]/g, '');

    const findCountryMatch = (value) => {
        const normalized = normalizeCountryValue(value);
        if (!normalized) return null;
        return countries.find((pais) => {
            const iso = pais.iso.toLowerCase();
            const nome = normalizeCountryValue(pais.name);
            return normalized === iso || nome.startsWith(normalized);
        });
    };

    const handleCountryQueryChange = (e) => {
        const value = e.target.value.toUpperCase();
        setCountryQuery(value);
        const match = findCountryMatch(value);
        if (match) {
            setSelectedCountry(match);
            setCountryQuery(match.iso);
            setTelefone((prev) => aplicarMascaraTelefone(prev, match));
        }
    };

    const handleCountryBlur = () => {
        setCountryQuery(selectedCountry.iso);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setCarregando(true);
        setErro('');

        const telefoneSemMascara = telefone.replace(/\D/g, '');
        const min = selectedCountry.minLength || 6;
        const max = selectedCountry.maxLength || 14;

        if (telefoneSemMascara.length < min || telefoneSemMascara.length > max) {
            showToast('O telefone esta incompleto para o pais selecionado.', 3000, 'error');
            setCarregando(false);
            return;
        }

        const telefoneComDDI = `${selectedCountry.ddi}${telefoneSemMascara}`;
        const result = await login(telefoneComDDI, senha);

        if (result.success) {
            showToast('Login realizado com sucesso!', 3000, 'success');
            navigate('/home');
        } else {
            showToast('Falha no login.', 3000, 'error');
            setErro(result.message || 'Falha no login');
        }

        setCarregando(false);
    };

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        telefoneInputRef.current?.focus();
    }, []);

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Login</h2>

            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.phoneRow}>
                    <label className={styles.ddiLabel} htmlFor="country-iso">
                        Sigla do pais
                    </label>
                    <input
                        id="country-iso"
                        className={styles.countryInput}
                        value={countryQuery}
                        onChange={handleCountryQueryChange}
                        onBlur={handleCountryBlur}
                        list="country-iso-list"
                        placeholder="BR"
                        autoComplete="off"
                        inputMode="text"
                    />
                    <datalist id="country-iso-list">
                        {countries.map((pais) => (
                            <option key={pais.iso} value={pais.iso} />
                        ))}
                    </datalist>

                    <input
                        type="text"
                        ref={telefoneInputRef}
                        placeholder={selectedCountry.placeholder}
                        value={telefone}
                        onChange={handleTelefoneChange}
                        className={styles.input}
                        required
                        inputMode="tel"
                    />
                </div>

                <input
                    type="password"
                    placeholder="Senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    className={styles.input}
                    required
                />

                <button type="submit" className={styles.button} disabled={carregando}>
                    {carregando ? 'Entrando...' : 'Entrar'}
                </button>

                {erro && <p className={styles.error}>{erro}</p>}

                <Link to="/recuperar" className={styles.link}>
                    Esqueceu sua senha?
                </Link>
            </form>
        </div>
    );
}

export default LoginPage;
